// @ts-nocheck
/* eslint-disable */
/// A scratch page for creating temporary tests for internal users
import { useRecoilValue } from 'recoil';
import { useRef, useCallback, useState, useEffect } from 'react';
import { Page } from './shared/Page';
import { Box } from '@mui/material';
import { useStreamingSocketCore } from 'hooks/bloomberg/streaming/useStreamingSocket';
import { StreamType } from 'types/shared';
import { dayjs } from 'util/shared/date';
import { useNavigate } from 'react-router-dom';
import { DashAccess, hasDashAccess } from 'types';
import { userDashAccessState } from 'states';

export const DebugPage = () => {
  const nav = useNavigate();
  const userDashAccess = useRecoilValue(userDashAccessState);
  if (!hasDashAccess(userDashAccess, DashAccess.INTERNAL)) {
    return navigate('/');
  }
  const sendStreamControlMsgRef = useRef();

  const registerStream = useCallback(() => {
    sendStreamControlMsgRef.current({
      action: 'subscribe',
      underlyings: ['SPX'],
      stream_types: StreamType.PRICES,
    });
  });

  const [latestCandle, setLatestCandle] = useState(null);

  const candleUpdate = useCallback((c) => {
    console.log(c);
    let [sym, timestamp, price] = c;
    timestamp = Number(timestamp);
    setLatestCandle({
      sym,
      timestamp,
      date: dayjs(timestamp).format(),
      delay_from_now: dayjs().valueOf() - dayjs(timestamp).valueOf(),
      price,
    });
  }, []);

  const { sendStreamControlMsg, reconnectSocket } = useStreamingSocketCore({
    enabled: true,
    socket: useRef<WebSocket | null>(null),
    socketRetries: useRef(0),
    onOpen: registerStream,
    onReconnect: registerStream,
    updateCandleCallback: candleUpdate,
  });
  useEffect(reconnectSocket, []);

  sendStreamControlMsgRef.current = sendStreamControlMsg;

  return (
    <Page>
      <Box sx={{ display: 'flex', height: '100%', flexDirection: 'column' }}>
        {JSON.stringify(latestCandle)}
      </Box>
    </Page>
  );
};
